<template lang="pug">
  nav.ChaptersNav(v-sticky="stickyConfig")
    div.ChaptersNav_stickyWrapper
      .ChaptersNav_timeline
        .ChaptersNav_timelinePart(v-for="(c, index) in chapters")
          .ChaptersNav_timelineProgress(:style="getTimelineStyle(index)")

      .ChaptersNav_content
        .ChaptersNav_contentBlock.ChaptersNav_contentBlock-title
          p.ChaptersNav_title
            span {{$t('chapters.title')}}
            span.ChaptersNav_titleSep
            span.ChaptersNav_titleNumber {{currentChapterNumber | chapterNumberFormat}}

        .ChaptersNav_contentBlock.ChaptersNav_contentBlock-pagination
          a.ChaptersNav_paginationLink(
            v-for="(c, index) in chapters"
            :key="index"
            :class="(currentChapterIndex == index ? ' is-active' : '')"
            :href="`#${index}`"
            @click="(e) => onPaginationClickHandler(e, index)")

        //- faux block simplement utilisé pour l'alignement des précédents
        .ChaptersNav_contentBlock.ChaptersNav_contentBlock-fake

</template>

<script>

import VueSticky from 'vue-sticky'
import raf from 'raf'

export default {
  directives: {
    'sticky': VueSticky
  },
  props: {
    chapters: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      currentChapterProgress: 0, // entre 0 et 1 - relative au à la hauteur du chapitre
      currentChapterIndex: 0,
      stickyConfig: {
        zIndex: 100,
        stickyTop: -1,
        disabled: false
      }
    }
  },
  computed: {
    currentChapterNumber () {
      return this.currentChapterIndex + 1
    },
    // boolean pour arrêter/démarrer le watch du scroll
    shouldWatchScroll () {
      // seulement s'il y a des chapitres
      return this.chapters.length > 0
    }
  },
  filters: {
    chapterNumberFormat (value) {
      return ('0' + value).slice(-2) // format 00
    }
  },
  watch: {
    shouldWatchScroll () {
      if (this.shouldWatchScroll) {
        this.stopWatchScroll() // au cas où il était déjà actif
        this.startWatchScroll()
      } else {
        this.stopWatchScroll()
      }
    }
  },
  beforeDestroy () {
    this.stopWatchScroll()
  },
  methods: {
    getTimelineStyle (index) {
      const style = {}

      // Si c'est un chapitre passé
      if (index < this.currentChapterIndex) {
        style['width'] = '100%'
      }
      // Si c'est un chapitre futur
      else if (index > this.currentChapterIndex) {
        style['width'] = '0%'
      }
      // Si c'est le chapitre actuel
      else {
        style['width'] = this.currentChapterProgress * 100 + '%'
      }

      return style
    },
    onPaginationClickHandler (e, index) {
      e.preventDefault()

      this.$scroll.to(this.chapters[index], this.$el.offsetHeight - window.innerHeight)
    },
    /**
     * Démarre le raf pour le scroll
     */
    startWatchScroll () {
      this._watchScrollRaf = this.$raf.create(this.watchScroll)
    },
    /**
     * raf pour le scroll
     */
    watchScroll () {
      const viewportRefPoint = window.innerHeight
      this.chapters.forEach((el, index) => {
        const elRect = el.getBoundingClientRect()
        // Si point de référence est compris dans l'élément actuel (entre sont top et top + height)
        if (elRect.top < viewportRefPoint && elRect.top + elRect.height > viewportRefPoint) {
          // On l'enregistre comme chapitre actuel
          this.currentChapterIndex = index
          // On calcul la progression relative du scroll
          this.currentChapterProgress = Math.abs(viewportRefPoint - elRect.top) / elRect.height
        }
      })

      // this._watchScrollRaf = raf(this.watchScroll)
    },
    /**
     * Arrête le raf pour le scroll
     */
    stopWatchScroll () {
      if (this._watchScrollRaf) {
        this.$raf.cancel(this._watchScrollRaf)
        this._watchScrollRaf = null
      }
    }
  }
}
</script>

<style lang="stylus">
.ChaptersNav

  &_stickyWrapper
    height: 54px
    background-color $black
    color $beige
    padding 0 40px

    @media $mq_m
      height: $chapterNav_height_m

    @media $mq_xl
      height: 78px

  &_timeline
    position: absolute
    top 0
    right 0
    left 0
    display: flex
    flex-direction row
    align-items stretch
    justify-content: center

  &_timelinePart
    flex-grow 1
    height: 5px

  &_timelineProgress
    height 100%
    background-color currentColor

  &_content
    display: flex
    flex-direction row
    align-items center
    justify-content: space-between
    max-width: 1330px
    box-sizing: border-box
    padding 20px 0
    margin 0 auto
    height: 100%

  &_contentBlock
    display: flex
    flex-direction row
    align-items center
    justify-content: center

    @media $mq_m
      width: calc(100%/3)

    &-title
      justify-content: flex-start

    &-fake
      @media $mq_s_only
        display: none

  &_title
    font-size: 10px
    line-height @font-size
    letter-spacing: .33em
    text-transform uppercase
    white-space: nowrap

    @media $mq_m
      font-size: 14px

  &_titleSep
    display: inline-block
    height: 1px
    width: 20px
    background-color currentColor
    margin 0 10px
    vertical-align: middle

    @media $mq_m
      height: 2px

  &_titleNumber
    display: inline-block
    vertical-align: middle
    width 30px // hotfix - empèche que l'alignement des éléments change lorsque le numéro change

  &_paginationLink
    cursor pointer
    color currentColor

    & + .ChaptersNav_paginationLink
      margin-left 20px

    &::before
      content ''
      display block
      width 10px
      height @width
      border-radius @width
      border 1px solid currentColor
      transition background-color .5s $ease

      @media $mq_m
        width 17px
        height @width
        border-radius @width

    &:hover,
    &.is-active
      &::before
        background-color currentColor

</style>
